import { useSelector } from '@xstate5/react';
import {
  Button,
  Popover,
  PopoverButton,
  IconButton,
  StyledPopoverPanel,
  PopoverItem,
  CloseButton,
} from '@crazyegginc/hatch';

import { useModal } from '/src/hooks';
import { AudienceEditorModal } from './AudienceEditorModal';
import { ConditionsPopover } from './ConditionsPopover';
import { ACTIONS } from '../machines/audience-builder';
import { AudienceSummaryLine } from './AudienceSummaryLine';

import { ReactComponent as PlusIcon } from '@crazyegginc/hatch/dist/images/icon-plus.svg';
import { ReactComponent as MenuIcon } from '@crazyegginc/hatch/dist/images/icon-menu-dots.svg';
import { ReactComponent as EditIcon } from '@crazyegginc/hatch/dist/images/icon-pencil-filled.svg';

export function ConfiguredAudience({ actorRef, disabled, onChange = () => {} }) {
  const modal = useModal();
  const definition = useSelector(actorRef, (state) => state.context.definition);
  const mode = useSelector(actorRef, (state) => state.context.mode);

  function showAudienceEditor(initialScrollCriteria = null) {
    modal.show(
      <AudienceEditorModal actorRef={actorRef} initialScrollCriteria={initialScrollCriteria} onChange={onChange} />,
    );
  }

  function onSelectAll() {
    if (disabled) {
      return;
    }

    actorRef.send({ type: ACTIONS.SELECT_ALL });
    onChange(null);
  }

  function onEditAudience() {
    if (disabled) {
      return;
    }

    actorRef.send({ type: ACTIONS.EDIT_EXISTING });
    showAudienceEditor();
  }

  function onSelectCriteria(criteria) {
    if (disabled) {
      return;
    }

    actorRef.send({ type: ACTIONS.EDIT_EXISTING, criteria });
    showAudienceEditor(criteria);
  }

  return (
    <div className="h-[50px] w-full flex items-center px-2.5 pr-20 rounded-lg border border-mystic-500 relative">
      <div className="flex min-w-0 flex-1 items-center overflow-hidden">
        <AudienceSummaryLine definition={definition} mode={mode} onClick={onEditAudience} disabled={disabled} />
        <Popover className="shrink-0">
          <PopoverButton as={Button} variant="secondary" size="sm" className="ml-2.5">
            <PlusIcon className="h-3 w-3 fill-current" />
          </PopoverButton>
          <ConditionsPopover mode={mode} onClick={onSelectCriteria} anchor="top start" />
        </Popover>
      </div>
      <Popover className="absolute right-10 top-[13px] shrink-0">
        <PopoverButton
          as={IconButton}
          icon={<MenuIcon className="h-4 w-4 fill-current" />}
          className="text-cadet-blue-500 hover:text-dodger-blue-500"
        />
        <StyledPopoverPanel align="right" className="!w-48" data-testid="audience-menu-panel">
          {({ close }) => (
            <>
              <PopoverItem
                onClick={() => {
                  onEditAudience();
                  close();
                }}
                className="group flex items-center"
              >
                <EditIcon className="mr-2.5 h-3.5 w-3.5 fill-current text-dodger-blue-300 group-hover:text-dodger-blue-500" />
                Edit Audience
              </PopoverItem>
            </>
          )}
        </StyledPopoverPanel>
      </Popover>
      <CloseButton
        onClick={onSelectAll}
        label="remove condition"
        buttonClass="!top-[19px] group"
        iconClass="group-hover:text-radical-red-500"
      />
    </div>
  );
}
